import { Link } from 'react-router';
import { ArrowRight, BarChart3, Link2, Wallet, Users } from 'lucide-react';
import { PublicLayout } from '@/routes/_layout';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';

export function meta() {
  return [
    { title: 'Red de creadores de contenido Educrea' },
    {
      name: 'description',
      content: 'Panel de gestión de creadores de contenido de la Red Educrea.',
    },
  ];
}

const features = [
  {
    icon: Link2,
    title: 'Links de creador',
    description: 'Obtén tu link único y compártelo en cualquier RRSS.',
  },
  {
    icon: BarChart3,
    title: 'Estadísticas en vivo',
    description: 'Clics, conversiones, tasa de conversión y Ganancias actualizadas.',
  },
  {
    icon: Wallet,
    title: 'Comisiones claras',
    description: 'Cada venta atribuida se traduce en una comisión visible.',
  },
  {
    icon: Users,
    title: 'Panel del equipo',
    description: 'El equipo de Educrea te entregará tu link único, validará conversiones y pagos.',
  },
];

export default function Index() {
  return (
    <PublicLayout>
      <section className="bg-primary-light">
        <div className="mx-auto max-w-6xl px-6 py-16 sm:py-24">
          <div className="max-w-3xl">
            <div className="mb-3 inline-flex items-center rounded-full bg-primary/10 px-3 py-1 text-xs font-semibold uppercase tracking-wider text-primary">
              Red de creadores de contenido
            </div>
            <h1 className="text-4xl font-extrabold tracking-tight text-foreground sm:text-5xl">
              Comparte contenidos de los cursos de Educrea, aporta conocimiento a tu comunidad y
              recibe una comisión cada vez que alguien acceda a un curso a través de tu enlace.
            </h1>
            <p className="mt-4 text-lg text-muted-foreground">
              Gestiona tus enlaces, estadísticas, conversiones y comisiones desde un único panel.
              Comienza en minutos y monetiza el impacto de tus contenidos.
            </p>
            <div className="mt-8 flex flex-col gap-3 sm:flex-row">
              <Button asChild size="lg" variant="primary">
                <Link to="/login">
                  Ingresar a mi cuenta
                  <ArrowRight className="h-4 w-4" />
                </Link>
              </Button>
              <Button asChild size="lg" variant="outline">
                <Link to="/apply">Creador de contenido</Link>
              </Button>
            </div>
          </div>
        </div>
      </section>

      <section className="mx-auto max-w-6xl px-6 py-16">
        <div className="mb-10">
          <h2 className="text-2xl font-bold text-foreground sm:text-3xl">¿Qué te ofrece la Red?</h2>
          <p className="mt-2 text-muted-foreground">
            Todas las herramientas para operar el programa sin fricción.
          </p>
        </div>
        <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {features.map(({ icon: Icon, title, description }) => (
            <Card key={title}>
              <CardHeader>
                <div className="mb-2 flex h-10 w-10 items-center justify-center rounded-md bg-primary-light text-primary">
                  <Icon className="h-5 w-5" />
                </div>
                <CardTitle className="text-lg">{title}</CardTitle>
                <CardDescription>{description}</CardDescription>
              </CardHeader>
            </Card>
          ))}
        </div>
      </section>

      <section className="bg-primary-light">
        <div className="mx-auto max-w-6xl px-6 py-16">
          <div className="grid gap-8 lg:grid-cols-2">
            <div>
              <h2 className="text-2xl font-bold text-foreground sm:text-3xl">
                ¿Cómo funciona la atribución?
              </h2>
              <p className="mt-2 text-muted-foreground">
                Cuando alguien hace clic en tu link, se asigna una cookie de 48 horas. Si compra
                dentro de esa ventana, la venta se te atribuye automáticamente.
              </p>
              <ul className="mt-6 space-y-2 text-sm text-foreground">
                <li>1. Comparte tu link de creador</li>
                <li>2. La persona navega y compra</li>
                <li>3. La comisión se registra en tu panel</li>
                <li>4. Educrea aprueba y paga según calendario</li>
              </ul>
            </div>
            <Card>
              <CardHeader>
                <CardTitle>Ejemplo</CardTitle>
                <CardDescription>Una venta atribuida</CardDescription>
              </CardHeader>
              <CardContent>
                <dl className="space-y-2 text-sm">
                  <div className="flex justify-between">
                    <dt className="text-muted-foreground">Curso</dt>
                    <dd className="font-medium">Detección y abordaje del ciberacoso escolar.</dd>
                  </div>
                  <div className="flex justify-between">
                    <dt className="text-muted-foreground">Venta</dt>
                    <dd className="font-medium">$9.900.- CLP</dd>
                  </div>
                  <div className="flex justify-between">
                    <dt className="text-muted-foreground">Comisión (50%)</dt>
                    <dd className="font-bold text-success">$4.450.- CLP</dd>
                  </div>
                </dl>
              </CardContent>
            </Card>
          </div>
        </div>
      </section>
    </PublicLayout>
  );
}
